// extracted by mini-css-extract-plugin
export default {"htmlContent":"htmlContent__htmlContent____O8tq"};